import {
  AboutHeaderContainer,
  EuphaFamily,
  WeAreEupha,
} from "./AboutHeader.style";

const AboutHeader = ({
  firstWord,
  secondWord,
  subtitleOne,
  subtitleTwoFirst,
  subtitleTwoSecond,
}) => {
  return (
    <AboutHeaderContainer>
      <EuphaFamily>
        <h1>{firstWord}</h1>
        <h1>{secondWord}</h1>
      </EuphaFamily>
      <WeAreEupha>
        <p>{subtitleOne}</p>
        <p>
          <span>{subtitleTwoFirst}</span> {subtitleTwoSecond}
        </p>
      </WeAreEupha>
    </AboutHeaderContainer>
  );
};

export default AboutHeader;
